//dependencies
import { runInAction } from "mobx";
import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";

export class UpdateMentorAttendanceRequest {
    public studentSessionId: Guid = "";
    public didAttend: boolean = false;
    public planForSession: string = "";
}

export class UpdateMentorStudentAttendance extends Endpoint<UpdateMentorAttendanceRequest, Response> {
    constructor() {
        super();
        this.verb(Http.Put);
        this.path(AppUrls.Server.MentorRole.EditStudentAttendend);
    }

    public async HandleRequestAsync(request: UpdateMentorAttendanceRequest): Promise<any> {
        return Promise.resolve(request);
    }

    public async HandleResponseAsync(response: any): Promise<any> {
        runInAction(() => {});
    }
}
